import React, { useEffect, useState } from "react";
import "./style.scss";
import GenerateCoupon from "../../../components/Affiliate/GetLink/GenerateCoupon";
import Commission from "../../../components/Affiliate/GetLink/Commission";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { returnMessages } from "../../../utils/store/reducers/Message";
import { returnErrors } from "../../../utils/store/reducers/Error";
import { getAfsPayoutList } from "../../../utils/apis/payments";

function GetLink() {
  const dispatch = useDispatch();
  const [createdLink, setCreatedLink] = useState([]);
  const { idToken } = useSelector((state) => state.auth);
  const formik = useFormik({
    initialValues: {
      percentage: 15,
      code: "",
      percent_repeat: "",
    },
    // validationSchema: Yup.object({
    //   percentage: Yup.number()
    //     .min(0, "Percentage must be at least 0")
    //     .max(100, "Percentage must be at most 100")
    //     .required("Percentage is required"),
    //   code: Yup.string().required("Code is required"),
    // }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${idToken}`, // Fixed the typo
          },
        };
        const response = await axios.post(
          "affiliates/create-link/", // Fixed the URL typo
          values,
          config
        );
        if (response.status < 399) {
          dispatch(returnMessages("successfully created Affiliate Link", 200));
          formik.resetForm();
          setCreatedLink(response.data);
        }
              } catch (error) {
        dispatch(
          returnErrors(error.response.data.detail, 200)
        ); // Enhanced error message
      } finally {
        setSubmitting(false);
      }
    },
  });
  useEffect(() => {
    formik.setFieldValue("percent_repeat", 15 - formik.values.percentage);
  }, [formik.values.percentage]);
  const [afsPayoutList, setAfsPayoutList] = useState([]);
  const fetchPayout = async () => {
    try {
      const response = await getAfsPayoutList(idToken);
      setAfsPayoutList(response);
    } catch (error) {
      console.error("Error fetching PFS list:", error);
    }
  };
  useEffect(() => {
    fetchPayout();
  }, []);

  return (
    <div className="getlink">
      <GenerateCoupon formik={formik} createdLink={createdLink} />
      <Commission afsPayoutList={afsPayoutList} />
    </div>
  );
}

export default GetLink;
